export const useStyledFileUploaderStyles = (theme) => {
    return {
        bottomAttachmentDrawer: {
            p: 2,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16
        }
    };
};
